module.exports = __webpack_public_path__ + "static/img/6tuban.39b2ddeb.jpg";